import type {PageRouteConfig} from '@router';

import PinPaymentSuccess from 'modules/Services/PromotionCenter/Pin/PaymentSuccess/PinPaymentSuccess';

export function createPromotionCenterPinPaymentSuccessRoute(): PageRouteConfig {
  return {
    element: <PinPaymentSuccess />,
    layout: {
      title: '',
      hasNavigate: false,
      hasHeader: false,
      hasBack: true,
      hasLeftIcon: false,
      link: -1
    }
  };
}
